const Warranty = {
    warrantyProductList: () => 'store/warranty/claimed-products/approval',
    warrantyProductDetail: (id: string) => `store/warranty/claimed-products/approval/${id}`,
    approveReject: (id:string) =>`store/warranty/status/${id}`,
}
export default Warranty